import { FC } from "react";
import image from "../../Assets/TalentOnDemand/features-hero.png";
import bgImage from "../../Assets/homev2/el-bg.png";

const TalentOnDemandFeaturesHero: FC = () => {
    return (
        <section
            className="w-full bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative mb-10"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between gap-4 lg:gap-8 items-center">
                <div>
                    <h2 className="text-3xl md:text-5xl lg:text-7xl text-black font-semibold text-center">
                        Streamline Hiring Process<br />
                        with Advanced AI Technology
                    </h2>
                </div>
                <div className=" relative">
                    <img
                        src={image}
                        alt="Customize my solution"
                        width="100%"
                        height="100%"
                        loading="lazy"
                    />

                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandFeaturesHero;